import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class AllinMerchantAccountAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getAllinMerchantAccountList', {
      url: '/admin/allinNumber/index',
      name: 'list',
      label: '列表'
    }],
    // ['sanYouDevice', {
    //   url: '/admin/aqara/sanYouDevice',
    //   name: 'sanYou-device-list',
    //   label: '授权闪优设备列表',
    // }],
    ['addAllinMerchantAccount', {
      url: '/admin/allinNumber/add',
      name: 'add',
      label: '添加'
    }],
    ['updateAllinMerchantAccount', {
      url: '/admin/allinNumber/edit',
      name: 'edit',
      label: '编辑'
    }],
    ['markAllinMerchantAccount', {
      url: '/admin/allinNumber/mark',
      name: 'mark-alin-merchant-account',
      label: '标记通联商户号'
    }],
    ['useAllinMerchantAccount', {
      url: '/admin/allinNumber/use',
      name: 'use-alin-merchant-account',
      label: '使用通联商户号'
    }],
    ['getProviceList', {
      url: '/admin/city/allinpay/province',
      name: 'get-provice-list',
      label: '获取地区省列表'
    }],
    // ['searchVenueList', {
    //   url: '/admin/coupons/shop/list',
    //   name: 'shop-list',
    //   label: '店铺列表',
    //   // hidden: true
    // }],
    // ['exportExcelStoragelockerList', {
    //   url: '/admin/shopBox/export',
    //   name: 'export-excel',
    //   label: '导出',
    // }],
  ])

  // 通联商户号列表
  public getAllinMerchantAccountList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getAllinMerchantAccountList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  

  // 闪优设备列表
//   public sanYouDevice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
//     const apiUrls = this.apiUrls

//     const url = apiUrls.get('sanYouDevice').url

//     this.BasicPost(url, {
//         ...params
//     }, false, false, false, successCb, failCb, showLoading)
//    }

  // 修改通联商户号
  public updateAllinMerchantAccount(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateAllinMerchantAccount').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 添加通联商户号
  public addAllinMerchantAccount(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addAllinMerchantAccount').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 标记通联商户号
  public markAllinMerchantAccount(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('markAllinMerchantAccount').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 使用通联商户号
  public useAllinMerchantAccount(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('useAllinMerchantAccount').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

   // 获取地区省列表
  public getProviceList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getProviceList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 搜索店铺列表
  // public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('searchVenueList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 导出球杆柜管理列表
  // public exportExcelStoragelockerList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('exportExcelStoragelockerList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
}